import {Pipe, PipeTransform} from '@angular/core';
import {TypeLienUsage} from 'app/shared/model/type-lien-usage';

@Pipe({name: 'typeLienUsage'})
export class TypeLienUsagePipe implements PipeTransform {

    transform(value: TypeLienUsage): any {
        switch (value) {
            case 'ADMINISTRATEUR':
                return 'Administrateur';
            case 'GESTIONNAIRE':
                return 'Gestionnaire';
            case 'EXPLOITANT':
                return 'Exploitant';
            case 'VISITEUR':
                return 'Visiteur';

        }
    }

}
